import React, { useMemo } from 'react';
import { default as NHead } from 'next/head';
import { CliqueiAcheiData, Restaurant } from '@app/types';
import { URL_SMALL_LOGO } from '@app/config/urls';
import { getCityByUrl } from '@app/utils/city';
import { useRouter } from 'next/router';

type Props = {
  cliqueiAcheiData: CliqueiAcheiData;
  restaurant: Restaurant;
};

const DEFAULT_IMAGE =
  'https://www.cliqueiachei.com.br/logotipo-logomarca-cliquei-achei/cliquei-achei-pedidos-image-share.png';

export default function Head({ cliqueiAcheiData, restaurant }: Props) {
  const logo = cliqueiAcheiData?.Url_BannerPagina ? URL_SMALL_LOGO + cliqueiAcheiData.Url_BannerPagina : null;
  const title = useMemo(() => {
    const city = getCityByUrl(cliqueiAcheiData.Url_Cidade);
    return `Cardápio Digital ${cliqueiAcheiData?.NomePuro ?? ''} | ${city?.Nom_Cidade ?? ''} ${city?.Sigla_UF ?? ''}`;
  }, [cliqueiAcheiData]);

  const router = useRouter();

  return (
    <NHead>
      <title>{title}</title>
      <meta property="og:url" content="https://cardapio.cliqueiachei.com" />
      <meta property="og:image" content={logo ?? DEFAULT_IMAGE} />
      <meta property="og:site_name" content={title} />
      <meta property="og:title" content={title} />
      <meta property="al:ios:url" content={`cliqueiachei:/${router.asPath}`} />
      <meta property="al:android:url" content={`cliqueiachei:/${router.asPath}`} />
      {restaurant.cliqueiAcheiId < 0 && <meta name="robots" content="noindex" />}

      {/* <script async src="https://www.googletagmanager.com/gtag/js?id=G-D8VNL43V5B" />
      <script
        dangerouslySetInnerHTML={{
          __html: `
                           
              `,
        }}
      /> */}
    </NHead>
  );
}
